import axios from "axios";
import { message } from "antd";
import { get } from "lodash";

import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
  COUNT,
  BULK_CREATE,
  BULK_DELETE,
  BULK_UPDATE,
  GET,
} from "./requestType";
import { roughLogOut } from "../session";
import { host } from "config";

export const defaultHeaders = () => {
  const token = localStorage.getItem("JwtToken");
  const headers = {
    "Content-Type": "application/json",
    "X-Access-Token": token,
  };
  return headers;
};

export const getOptionByType = (
  type = GET,
  resource = "",
  param = {},
  options = {}
) => {
  let option = { url: "", method: "" };
  switch (type) {
    case GET:
      option.method = "GET";
      option.url = `${host}/${resource}`;
      break;
    case GET_LIST:
      option.method = "GET";
      option.url = `${host}/${resource}`;
      break;
    case GET_ONE:
      option.method = "GET";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}`;
      break;
    case BULK_CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}s`;
      break;
    case UPDATE:
      option.method = "PUT";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case BULK_UPDATE:
      option.method = "PATCH";
      option.url = `${host}/${resource}/bulkupdate`;
      break;
    case DELETE:
      option.method = "DELETE";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case BULK_DELETE:
      option.method = "DELETE";
      option.url = `${host}/${resource}/bulkdelete`;
      break;
    case COUNT:
      option.method = "GET";
      option.url = `${host}/${resource}/count`;
      break;
    default:
      return -1;
  }

  switch (option.method) {
    case "GET":
      option.params = param;
      break;
    case "POST":
      option.data = param.body;
      break;
    case "PATCH":
    case "PUT":
      option.data = param.body;
      break;
    case "DELETE":
      break;
    default:
      option.params = param;
      option.data = param.body;
      break;
  }

  if (options.path) option.url = `${host}/${options.path}`;
  return option;
};

export const dataProvider = (type, resource, params, options) => {
  const option = getOptionByType(type, resource, params, options);
  if (option === -1) throw Error("no match request type");

  return axios({
    ...option,
    headers: defaultHeaders(),
  })
    .then((res) => {
      if (
        [CREATE, UPDATE, DELETE, BULK_CREATE, BULK_DELETE, BULK_UPDATE].indexOf(
          type
        ) >= 0
      ) {
        message.destroy();
        message.success("成功");
      }

      return res;
    })
    .catch((error) => {
      if (!error || error.response.status === 401) {
        roughLogOut();
      }
      if (get(error, "response.data")) {
        message.destroy();
        message.error(get(error, "response.data") || "錯誤");
      }
      return {
        err: true,
        status: error.response.status,
        message: get(error, "response.data") || error.message,
      };
    });
};
